import { render } from "./App.vue?vue&type=template&id=45c4292b&scoped=true&lang=html&bindings={\"name\":\"data\",\"position\":\"data\",\"email\":\"data\",\"phone\":\"data\",\"mobile\":\"data\",\"address\":\"data\",\"color\":\"data\",\"hide\":\"data\",\"styles\":\"data\",\"selectedStyle\":\"data\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=45c4292b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-45c4292b"

export default script